const concatenatedPlatformLabel = (platform) => {
  const keys = Object.keys(platform || {});

  return keys?.filter((el) => platform[el] !== '' && Number.parseInt(platform[el], 10) !== 0)
    .map((el) => `${el} ${platform[el]}%`);
};

export default concatenatedPlatformLabel;
